// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"28739325","144":"7273d341","213":"25444483","236":"4cba6438","239":"68c5d1b0","322":"4425da58","371":"9ecaf7c0","455":"d5ddec37","479":"83ca005f","635":"b6aaf652","762":"e096d1da","763":"9c774879","962":"db77b2a0"}[chunkId] + ".chunk.js";
};